import {
	TimeLabelGroup,
	useDeleteTimeLabelGroupMutation,
	useGetAllTimeLabelGroupsLazyQuery,
	PageInfo,
} from "@repo/server-api";
import { useState } from "react";

import { DataSource } from "@repo/legacy/components/shared/lists/DataSource";
import { PaginationModel } from "@repo/legacy/components/shared/lists/PaginationModel";

export function useAllTimeLabelGroupsDataSource(): DataSource<TimeLabelGroup> {
	const [rows, setRows] = useState<TimeLabelGroup[]>([]);
	const [rowCount, setRowCount] = useState(0);
	const [isLoading, setIsLoading] = useState(false);
	const [, setPageInfo] = useState<PageInfo | null>(null);
	const [searchBy, setSearchBy] = useState<string>("");
	const [pageModal, setPageModal] = useState<PaginationModel>({
		page: 0,
		pageSize: 10,
	});
	const [contactId, setContactId] = useState<string>("");

	const [deleteTimeLabelGroup] = useDeleteTimeLabelGroupMutation({
		onCompleted(data: { deleteTimeLabelGroup: { boolean: boolean } }) {
			if (data.deleteTimeLabelGroup.boolean) {
				refresh();
			}
		},
	});

	const [getTimeLabelGroups] = useGetAllTimeLabelGroupsLazyQuery({
		fetchPolicy: "no-cache",
		onCompleted(data: {
			allTimeLabelGroup: {
				nodes: TimeLabelGroup[];
				totalCount: number;
				pageInfo: PageInfo;
			} | null;
		}) {
			if (data && data.allTimeLabelGroup) {
				setRows(data.allTimeLabelGroup.nodes as TimeLabelGroup[]);
				setRowCount(data.allTimeLabelGroup.totalCount);
				setPageInfo(data.allTimeLabelGroup.pageInfo);
				setIsLoading(false);
			}
		},
	});

	const refresh = () => {
		fetchDataForContact(pageModal, searchBy, contactId);
	};

	const fetchDataForId = (contactId: string) => {
		fetchDataForContact(pageModal, searchBy, contactId);
	};

	const fetchDataForContact = (page: PaginationModel, searchBy: string, contactId: string) => {
		setIsLoading(true);
		setSearchBy(searchBy);
		setPageModal(page);
		setContactId(contactId);
		if (contactId !== "") {
			getTimeLabelGroups({
				variables: {
					companyId: contactId,
					first: page.pageSize,
					after: (page.pageSize * page.page).toString(),
					name: searchBy,
				},
			}).then(
				(response: {
					data: {
						allTimeLabelGroup: {
							nodes: TimeLabelGroup[];
							totalCount: number;
							pageInfo: PageInfo;
						} | null;
					} | null;
				}) => {
					if (response.data && response.data.allTimeLabelGroup) {
						setRows(response.data.allTimeLabelGroup.nodes as TimeLabelGroup[]);
						setRowCount(response.data.allTimeLabelGroup.totalCount);
						setPageInfo(response.data.allTimeLabelGroup.pageInfo);
						setIsLoading(false);
					}
				},
			);
		}
	};

	const deleteDataForTimeLabel = (id: string, version: number) => {
		deleteTimeLabelGroup({ variables: { id: id, version: version } });
	};

	return {
		rows,
		rowCount,
		isLoading,
		fetchDataForContact,
		fetchDataForId,
		deleteDataForTimeLabel,
		refresh,
	};
}
